// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rec-arrow,\n.rec-arrow:hover:enabled,\n.rec-arrow:focus:enabled {\n\tbackground-color: white !important;\n\tbox-shadow: 0 0 0 0 !important;\n}\n\n.rec-pagination {\n\tdisplay: none !important;\n}\n\n.rec-arrow:hover:enabled,\n.rec-arrow:focus:enabled {\n\tcolor: #333 !important;\n}\n", ""]);
// Exports
module.exports = exports;
